<template>
  <div>
    <!-- 会員種類情報 -->
    <el-row type="flex" align="middle" :gutter="20">
      <el-col :span="4">
        <p>{{ $locale("membership.memberList.dialog.information") }}</p>
      </el-col>
      <el-col :span="20" class="ta-r">
          <el-button :disabled="getDetailDisable" @click="openMemberShipType_fn" class="egl-btn-yellow">{{ $locale("membership.memberList.dialog.information.change") }}</el-button>
          <el-button :disabled="getDetailDisable" @click="openRankChange_fn" class="egl-btn-yellow">{{ $locale("membership.memberList.dialog.information.rank-change") }}</el-button>
          <el-button :disabled="getDetailDisable" @click="isRankUpNumberChangeOpen = true" class="egl-btn-yellow">{{ $locale("membership.memberList.dialog.information.rankUpNumber-change") }}</el-button>
          <el-button :disabled="getDetailDisable" @click="quitMember_fn" class="egl-btn-yellow" style="background-color: rgba(225, 76, 76, 1);">{{ $locale("membership.memberList.dialog.information.cancel") }}</el-button>
        </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.coupon.memberType')">{{ propForm.member && propForm.member.memberShip ? propForm.member.memberShip.name : "" }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.coupon.rank')">{{ propForm.member && propForm.member.memberShipRank ? propForm.member.memberShipRank.name : "" }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item label="有効期限">{{
          !(propForm.member || {}).expireTime || isNaN((propForm.member || {}).expireTime) ? '期限なし' : $moment((propForm.member || {}).expireTime).format("YYYY.MM.DD")
        }}</el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('membership.coupon.enrollmentDate')">{{
          !(propForm.member || {}).joinTime || isNaN((propForm.member || {}).joinTime) ? '' : $moment((propForm.member || {}).joinTime).format("YYYY.MM.DD")
        }}</el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- 残り何回でアップグレード -->
        <el-form-item :label="$locale('membership.memberList.upgradesLeft')">
          <el-row :gutter="5">
              <el-col>{{ getNeedMoreViews() }}</el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- UpdateDialog 「会員種類変更」-->
    <UpdateDialog :title="$locale('membership.memberList.dialog.information.change')" :isOpen.sync="isMemberTypeOpen" ref="MemberTypeDialog">
      <DialogItem
        :isShowCheckBox="true"
        :propForm="memberShipTypeObj"
        listTitle="付与する会員種類を選択してください"
        :targetList="getMemberShipList"
        targetKey="memberShipId"
        @close="isMemberTypeOpen = false"
        @save="updateMemberShipType_fn"
      />
    </UpdateDialog>
    <!-- ランク変更 -->
    <UpdateDialog :title="$locale('membership.memberList.dialog.information.rank-change')" :isOpen.sync="isRankChangeOpen" ref="RankChangeDialog">
      <DialogItem
        :propForm="memberShipRankObj"
        listTitle="付与するランクを選択してください"
        :targetList="getRankListForMemberShipId()"
        targetKey="memberShipRankId"
        :isHidePicker="true"
        @close="isRankChangeOpen = false"
        @save="rankChange_fn"
      />
    </UpdateDialog>
    <!-- ランクアップまでの回数変更 -->
    <el-dialog
      :visible.sync="isRankUpNumberChangeOpen"
      :show-close="false"
      class="egl-dialog-elm channel-dialog"
      :title="$locale('membership.memberList.dialog.information.rankUpNumber-change')"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-input v-model.number="rankUpNumber" @input="validNumber" placeholder="ランクアップまでの回数変更を入力してください" />
      <el-row :gutter="20" type="flex" justify="center" style="margin-top: 37px;">
        <el-col :span="16" style="display: flex; justify-content: space-around;">
          <template>
            <el-button class="egl-btn-white" style="width: 250px;" @click="isRankUpNumberChangeOpen = false">
              {{ $locale("global.cancel") }}
            </el-button>
            <el-button :disabled="rankUpNumber == null || rankUpNumber === ''" class="egl-btn-yellow" style="width: 250px;background-color: rgba(249, 218, 73, 0.5);" @click="updateNumber_fn">
              {{ $locale("global.save") }}
            </el-button>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import UpdateDialog from "@/components/MemberShip/MemberList/updateDialog.vue";
import { displayConfirm } from "@/assets/js/membership";
import { updateMemberShipTypeService, updateMemberShipRankService, memberQuitService, adjustNeedMoreViewsService } from "@/helpers/service/api/membership";
import countDownAlert from "@/utils/countDownAlert";
import DialogItem from "@/components/MemberShip/MemberList/DialogItem.vue";
export default {
  inject: ["getList_fn", "memberShipList", "getListDetail_fn", "isDeatilDisable"],
  data() {
    return {
      isMemberTypeOpen: false,
      isRankChangeOpen: false,
      isRankUpNumberChangeOpen: false,
      memberShipTypeObj: {
        expireTimeLimit: true,
        userId: "",
        memberShipId: "",
        expireTime: null,
        remark: "",
      },
      memberShipRankObj: {
        userId: "",
        memberShipRankId: "",
        remark: "",
      },
      rankUpNumber: null,
    };
  },
  computed: {
    getMemberShipList() {
      return this.memberShipList();
    },
    getDetailDisable() {
      return this.isDeatilDisable();
    }
  },
  props: {
    propForm: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    openMemberShipType_fn() {
      this.isMemberTypeOpen = true;
      const { expireTime } = (this.propForm.member || {});

      this.memberShipTypeObj = {
        expireTimeLimit: expireTime !== null,
        userId: this.propForm.id,
        memberShipId: (this.propForm.member || {}).memberShipId,
        expireTime,
        remark: "",
      };
    },
    openRankChange_fn() {
      this.isRankChangeOpen = true;
      // 如果没找到对应的rankList memberShipRankId设置为"""
      this.memberShipRankObj = {
        userId: this.propForm.id,
        memberShipRankId: this.propForm.member && this.propForm.member.memberShipRank ? (this.propForm.member || {}).memberShipRankId : "",
        remark: "",
      };
    },
    updateMemberShipType_fn() {
      updateMemberShipTypeService({
        ...this.memberShipTypeObj,
        expireTime: this.memberShipTypeObj.expireTime ? this.$moment(this.memberShipTypeObj.expireTime).endOf('day').valueOf() : null,
      }).then(res => {
        if (res.success) {
          countDownAlert({ content:  this.$locale("global.operationSuccessful"), callback: () => {
            this.getListDetail_fn(this.propForm.id);
            this.getList_fn();
            this.$emit("refreshMemberShip");
            this.isMemberTypeOpen = false;
          } });
        }
      });
    },
    getRankListForMemberShipId() {
      if (this.propForm.member) {
        return (this.memberShipList().find(item => item.id === this.propForm.member.memberShipId) || {}).rankList;
      }
      return [];
    },
    rankChange_fn() {
      updateMemberShipRankService(this.memberShipRankObj).then(res => {
        if (res.success) {
          countDownAlert({ content:  this.$locale("global.operationSuccessful"), callback: () => {
            this.getListDetail_fn(this.propForm.id);
            this.getList_fn();
            this.$emit("refreshRank");
            this.isRankChangeOpen = false;
          } });
        }
      });
    },
    quitMember_fn() {
      const elContent = `<p style="margin-bottom:20px;text-align:left;">解約すると、お客様がすぐ会員優待を利用できなくなります。</p>
      <p style="margin-bottom:20px;text-align:left;">再度にご利用するには、お客様から再入会が必要があります。</p>
      <p style="color: rgba(255, 80, 80);margin-bottom:20px;text-align:left;">この操作は、復元はできません。</p>
      <p>よろしいでしょうか。</p>`;
      displayConfirm(elContent, this.$locale("membership.memberList.dialog.quit"), () => {
        memberQuitService({
          userId: this.propForm.id
        }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: () => {
              this.getListDetail_fn(this.propForm.id);
              this.getList_fn();
            } });
          }
        });
      });
    },
    updateNumber_fn() {
      adjustNeedMoreViewsService({
        count: this.rankUpNumber,
        userId: this.propForm.id,
      }).then(() => {
        this.isRankUpNumberChangeOpen = false;
        countDownAlert({ content:  this.$locale("global.operationSuccessful"), callback: () => {
          this.getListDetail_fn(this.propForm.id);
          this.getList_fn();
        } });
      })
    },
    validNumber(value) {
      if (!/^[0-9]\d*$/.test(value)) {
        this.rankUpNumber = null;
      }
    },
    getNeedMoreViews() {
      // 判断needMoreViews是否存在
      // 判断needMoreViews是否小于0，小于0设置为0
      // 返回needMoreViews
      if (this.propForm.member && this.propForm.member.needMoreViews !== null) {
        if (this.propForm.member.needMoreViews < 0) {
          return 0;
        }
        return this.propForm.member.needMoreViews;
      }
      return "-";
    }
  },
  components: {
    UpdateDialog,
    DialogItem
  },
  watch: {
    isRankUpNumberChangeOpen(newVal) {
      if (newVal) {
        this.rankUpNumber = (this.propForm.member || {}).needMoreViews;
      }
    }
  },
};
</script>
